// extracted by mini-css-extract-plugin
export default {"infoBlock":"BV0E9pw0o6","statistics":"DvLLS2d9ng"};